import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

import type { Promisable } from "@core/foundation/promise";
import { hasValue } from "@core/foundation/types";

type DeepLinkHandler = (url: string) => Promisable<void>;

export async function handleDeepLinks(
  handlers: readonly DeepLinkHandler[],
): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const executeHandlers = async (url: string): Promise<void> => {
    for (const handler of handlers) {
      await handler(url);
    }
  };

  await App.addListener("appUrlOpen", event => {
    // oxlint-disable-next-line typescript/no-floating-promises
    executeHandlers(event.url);
  });

  const launchUrl = await App.getLaunchUrl();

  if (hasValue(launchUrl)) {
    await executeHandlers(launchUrl.url);
  }
}
